var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-offer-button"},[_c('v-alert',{attrs:{"value":!!_vm.errorMessage,"type":"error"}},[_vm._v(_vm._s(_vm.errorMessage)+" ")]),_c('v-btn',{staticClass:"text-right",attrs:{"color":"error"},on:{"click":_vm.submit}},[_vm._v(" View Offer ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }